import React from 'react'
import "./Banner.css";

export default function Banner() {
    return (
        <>
            <img
                src={
                    process.env.PUBLIC_URL + "/assets/Images/Logo/entry-img.png"
                }
                className="banner-img"
                alt="entry-img"
            />
        </>
    )
}
